import {
  DELETE_PROVIDER_REQUEST,
  DELETE_PROVIDER_REQUEST_FAILURE,
  DELETE_PROVIDER_REQUEST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteProviderRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PROVIDER_REQUEST:
      return { ...state, loading: true };
    case DELETE_PROVIDER_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_PROVIDER_REQUEST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteProviderRequestReducer;
